<div class="p-grid ">
    <div class="p-col-9 m-auto p-mt-5">
      <div class="p-col-12">
        <h2 class="titulo">POLÍTICA DE PRIVACIDAD</h2>
        <div> 
            <div *ngFor="let content of contents">
                <h3 class="titulo-seccion">{{content.titulo}}</h3>
                <div class="cuerpo-seccion">
                {{content.cuerpo}}
                </div>
            </div>
        </div>
      </div>
    </div>
</div>
